(() => {
  if (window.sapShopSearchReady) return;
  window.sapShopSearchReady = true;
  document.querySelectorAll('[data-shop-sort-only]').forEach(form => {
    const select = form.querySelector('[name="sort_by"]');
    if (!select) return;
    form.querySelectorAll('[data-shop-sort-fallback]').forEach(control => control.hidden = true);
    select.addEventListener('change', () => form.requestSubmit());
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = event.target.closest('.sap-shop-filter[open]');
    if (!open) return;
    open.open = false;
    open.querySelector('summary').focus();
  });
  document.addEventListener('click', event => {
    const flip = event.target.closest('[data-shop-flip]');
    if (flip) {
      const turned = flip.getAttribute('aria-pressed') !== 'true';
      flip.setAttribute('aria-pressed', String(turned));
      const photo = flip.closest('[data-shop-photo]');
      photo.toggleAttribute('data-turned', turned);
      photo.querySelector('[data-shop-back]').setAttribute('aria-hidden', String(!turned));
    }
    document.querySelectorAll('.sap-shop-filter[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
})();

(() => {
  if (window.sapShopRoutineReady) return;
  window.sapShopRoutineReady = true;
  const controllers = new WeakMap();
  const initialize = scope => {
    scope.querySelectorAll('.sap-shop-products:has([data-shop-routine])').forEach(section => {
      if (controllers.has(section)) return;
      const controller = new AbortController();
      controllers.set(section, controller);
      const options = {signal: controller.signal};
      const sheet = section.querySelector('.sap-shop-routine-sheet');
      const opener = section.querySelector('[data-shop-filter-open]');
      const count = section.querySelector('[data-shop-count]');
      const cards = [...section.querySelectorAll('.sap-shop-grid > .sap-shop-card')];
      const matches = {time: {morning: ['clean', 'tone', 'day', 'the-full-system'], evening: ['clean', 'tone', 'night', 'the-full-system']}, product: {cleanser: ['clean'], toner: ['tone'], serum: ['day', 'night']}, set: {fs: ['the-full-system']}};
      const selected = new Map();
      const media = matchMedia('(min-width: 768px)');
      const drops = [...section.querySelectorAll('.sap-shop-routine-toggle')];
      sheet.querySelectorAll('[data-shop-group]').forEach(group => {
        const target = section.querySelector('[data-shop-drop="' + group.dataset.shopGroup + '"] .sap-shop-routine-options');
        target.setAttribute('role', 'group');
        target.setAttribute('aria-label', group.querySelector('legend').textContent);
        target.replaceChildren();
        group.querySelectorAll('[data-shop-choice]').forEach(button => target.append(button.cloneNode(true)));
      });
      const closeDrops = except => drops.forEach(button => {
        if (button === except) return;
        button.setAttribute('aria-expanded', 'false');
        section.querySelector('#' + CSS.escape(button.getAttribute('aria-controls'))).hidden = true;
      });
      const apply = () => {
        let visible = 0;
        cards.forEach(card => {
          const handle = new URL(card.querySelector('.sap-shop-card__image').href).pathname.split('/').filter(Boolean).at(-1);
          card.hidden = ![...selected].every(([group, value]) => matches[group][value].includes(handle));
          if (!card.hidden) visible++;
        });
        const words = visible === 1 ? count.dataset.one : count.dataset.many.replace('__N__', String(visible));
        count.textContent = words;
        section.querySelector('[data-shop-show]').textContent = 'Show ' + words;
        section.querySelectorAll('[data-shop-choice]').forEach(button => {
          const [group, value] = button.dataset.shopChoice.split(':');
          button.setAttribute('aria-pressed', String(selected.get(group) === value));
        });
        section.querySelectorAll('[data-shop-value]').forEach(value => {
          const choice = selected.get(value.dataset.shopValue);
          value.textContent = choice ? sheet.querySelector('[data-shop-choice="' + value.dataset.shopValue + ':' + choice + '"]').textContent : '';
        });
        section.querySelector('.sap-shop-routine-drops [data-shop-clear]').hidden = !selected.size;
        opener.classList.toggle('is-set', !!selected.size);
      };
      section.addEventListener('click', event => {
        const toggle = event.target.closest('.sap-shop-routine-toggle');
        if (toggle) {
          const open = toggle.getAttribute('aria-expanded') !== 'true';
          closeDrops(toggle);
          toggle.setAttribute('aria-expanded', String(open));
          section.querySelector('#' + CSS.escape(toggle.getAttribute('aria-controls'))).hidden = !open;
          return;
        }
        const choice = event.target.closest('[data-shop-choice]');
        if (choice) {
          const [group, value] = choice.dataset.shopChoice.split(':');
          if (selected.get(group) === value) selected.delete(group); else selected.set(group, value);
          apply();
          const drop = choice.closest('[data-shop-drop]');
          if (drop) {closeDrops(); drop.querySelector('.sap-shop-routine-toggle').focus({preventScroll: true});}
        }
        if (event.target.closest('[data-shop-clear]')) {selected.clear(); apply(); closeDrops(); if (!sheet.open) drops[0].focus({preventScroll: true});}
        if (event.target.closest('[data-shop-filter-open]')) {sheet.showModal(); opener.setAttribute('aria-expanded', 'true'); sheet.querySelector('[data-shop-filter-close]').focus({preventScroll: true});}
        if (event.target.closest('[data-shop-filter-close]')) sheet.close();
      }, options);
      document.addEventListener('click', event => {if (!event.target.closest('.sap-shop-routine-drop')) closeDrops();}, options);
      section.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const drop = event.target.closest('[data-shop-drop]');
        if (drop) {closeDrops(); drop.querySelector('.sap-shop-routine-toggle').focus({preventScroll: true});}
      }, options);
      sheet.addEventListener('click', event => {
        const bounds = sheet.getBoundingClientRect();
        if (event.target === sheet && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) sheet.close();
      }, options);
      sheet.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const buttons = [...sheet.querySelectorAll('button')].filter(button => !button.disabled && button.getClientRects().length);
        const first = buttons[0], last = buttons.at(-1);
        if (event.shiftKey && document.activeElement === first) {event.preventDefault(); last.focus();}
        else if (!event.shiftKey && document.activeElement === last) {event.preventDefault(); first.focus();}
      }, options);
      sheet.addEventListener('close', () => {opener.setAttribute('aria-expanded', 'false'); (media.matches ? drops[0] : opener).focus({preventScroll: true});}, options);
      media.addEventListener('change', () => {closeDrops(); if (sheet.open) sheet.close();}, options);
      section.querySelectorAll('[data-shop-filter-ui]').forEach(control => control.hidden = false);
      apply();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.sap-shop-products').forEach(section => {controllers.get(section)?.abort(); controllers.delete(section);}));
})();

(() => {
  // Every word of the query, in any order, case-insensitive; a curly apostrophe counts as a straight one.
  const matchesAll = (text, query) => { const words = value => String(value).toLowerCase().replace(/’/g, "'").replace(/[\s\-(),\/.?:;"!&+·]+/g, ' '); const hay = ' ' + words(text); return words(query).split(' ').filter(Boolean).every(word => hay.includes(' ' + word)); };
  const restricted = document.querySelector('[data-search-unrestricted]');
  if (restricted) restricted.hidden = ![...new URL(location.href).searchParams.keys()].some(k => k === 'type' || k === 'sort_by' || k.startsWith('filter.'));
  document.querySelectorAll('[data-search-page-form]').forEach(form => {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    const input = form.elements.q;
    const clear = form.querySelector('[data-search-page-clear]');
    const updateClear = () => { clear.hidden = !input.value; };
    input.addEventListener('input', updateClear);
    clear.addEventListener('click', () => { input.value = ''; updateClear(); input.focus(); });
    updateClear();
  });
  const searchPage = document.querySelector('[data-sap-view="sap-search"]');
  const pageCount = searchPage?.querySelector('[data-search-page-count]');
  if (pageCount) {
    const count = searchPage.querySelectorAll('[data-search-native-result]').length + document.querySelectorAll('[data-search-custom] [data-search-record]').length;
    pageCount.textContent = count > 0 ? (count === 1 ? pageCount.dataset.one : pageCount.dataset.many.replace('__N__', count)) : '';
    pageCount.hidden = count === 0;
    // U5 ST-16 (hub 03:24, B): the tab title is Shopify's page_title, which counts native results only; swap its number for the count this page shows, keeping the rest of the title as the layout writes it.
    document.title = document.title.replace(/\b\d+ results?\b/, count === 1 ? '1 result' : count + ' results');
    const suggestions = document.querySelector('.sap-search-help [data-search-suggestions-heading]');
    if (suggestions) suggestions.textContent = count > 0 ? suggestions.dataset.results : suggestions.dataset.empty;
    const recovery = document.querySelector('.sap-search-help [data-search-recovery]');
    if (recovery) recovery.hidden = count > 0;
    document.querySelectorAll('[data-search-group-count]').forEach(groupCount => { groupCount.hidden = true; });
    const empty = searchPage.querySelector('[data-search-page-empty]');
    if (empty) {
      empty.hidden = count > 0;
      empty.querySelector('h2').textContent = empty.dataset.combinedHeading;
    }
    const emptyLinks = searchPage.querySelector('[data-search-empty-links]');
    if (emptyLinks) emptyLinks.hidden = count > 0;
  }
  document.querySelectorAll('[data-search-scope]').forEach(scope => {
    if (scope.dataset.ready) return; scope.dataset.ready = 'true';
    const form = scope.querySelector('form'), input = form.elements.q, clear = scope.querySelector('[data-scope-clear]'), status = scope.querySelector('[data-scope-count]'), whole = scope.querySelector('[data-scope-whole]');
    const rows = [...scope.querySelectorAll('[data-search-record]')]; let submittedURL = location.href;
    const collapseEmpty = scope.hasAttribute('data-collapse-empty'), list = scope.querySelector('.sap-search-scope__list');
    const urlFor = query => {const url = new URL(location.href); if (query) url.searchParams.set('q', query); else url.searchParams.delete('q'); return url;};
    const update = (write = false) => {
      const query = input.value.trim().toLowerCase(); let count = 0;
      rows.forEach(row => {row.hidden = (collapseEmpty && !query) || (!!query && !matchesAll(row.dataset.searchText, query)); if (!row.hidden) count++;});
      if (collapseEmpty && list) list.hidden = count === 0;
      clear.hidden = collapseEmpty ? !query : !input.value; status.textContent = query ? (count ? scope.dataset.count.replace('[count]',count) : scope.dataset.none) : '';
      whole.hidden = !!count || !query; const url = new URL(scope.dataset.route, location.origin); if (scope.dataset.searchView) url.searchParams.set('view',scope.dataset.searchView); url.searchParams.set('q',input.value.trim()); url.searchParams.set('options[prefix]','last');
      whole.href = url.href; whole.textContent = scope.dataset.whole.replace('[query]',input.value.trim());
      if (write) history.replaceState(null,'',urlFor(input.value.trim()));
    };
    const read = () => {submittedURL = location.href; input.value = new URL(location.href).searchParams.get('q') || ''; update();};
    input.addEventListener('input', event => {if (!event.isComposing) update(true);}); input.addEventListener('compositionend', () => update(true));
    const submit = () => {const next = urlFor(input.value.trim()); history.replaceState(null,'',submittedURL); if (next.href !== submittedURL) history.pushState(null,'',next); submittedURL = location.href; update();};
    form.addEventListener('submit', event => {event.preventDefault(); submit();});
    clear.addEventListener('click', () => {input.value = ''; submit(); input.focus();}); window.addEventListener('popstate',read); read();
  });
  const revealHash = () => {
    let id; try {id = decodeURIComponent(location.hash.slice(1));} catch {return;}
    if (!id) return; const target = document.getElementById(id);
    if (!target || !target.closest('.sap-search-ingredient-anchors,.sap-faq-topic__question')) return;
    const details = target.closest('details'); if (details) details.open = true;
    const focus = target.closest('summary') || target; focus.focus({preventScroll:true}); focus.scrollIntoView({block:'start'});
  };
  window.addEventListener('hashchange',revealHash); revealHash();
  const initialHash = location.hash;
  const restoreTopicFocus = () => requestAnimationFrame(() => {
    if (location.hash !== initialHash || document.activeElement !== document.body) return;
    let id; try { id = decodeURIComponent(initialHash.slice(1)); } catch { return; }
    if (!id.startsWith('q-')) return;
    const target = document.getElementById(id);
    const summary = target?.closest('.sap-faq-topic__question summary');
    if (summary?.parentElement.open) summary.focus({preventScroll:true});
  });
  if (document.readyState === 'complete') restoreTopicFocus();
  else window.addEventListener('load', restoreTopicFocus, {once:true});
})();
